(function () {
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const isCoarsePointer = window.matchMedia("(hover: none), (pointer: coarse)").matches;
  const MOBILE_SHOWCASE_MQ = window.matchMedia("(max-width: 1100px)");

  initReveal();
  initStatCountUp();
  initStickyShopCta();
  initProductStickyBar();
  initHeaderScrollState();
  initScrollProgress();
  initCursorSpotlight();
  initTouchGlow();
  initTouchTapFeedback();
  initHeroTilt();
  initFlavorShowcase();

  function initFlavorShowcase() {
    const section = document.querySelector(".flavor-showcase");
    if (!section) return;

    const listItems = section.querySelectorAll(".showcase-item[data-flavor]");
    const arts = section.querySelectorAll(".showcase-art img[data-flavor-art]");
    const slides = section.querySelectorAll(".showcase-slide[data-flavor]");
    const dots = section.querySelectorAll(".showcase-dot[data-flavor]");
    const track = section.querySelector(".showcase-carousel-track");
    if (!listItems.length && !slides.length) return;

    let activeFlavor = null;
    let rafId = null;
    let desktopScrollHandler = null;
    let mobileScrollHandler = null;
    let dotsBound = false;

    function setActive(flavor) {
      if (!flavor || flavor === activeFlavor) return;
      activeFlavor = flavor;
      section.setAttribute("data-active-flavor", flavor);
      listItems.forEach((item) => {
        item.classList.toggle("is-active", item.getAttribute("data-flavor") === flavor);
      });
      slides.forEach((slide) => {
        slide.classList.toggle("is-active", slide.getAttribute("data-flavor") === flavor);
      });
      arts.forEach((img) => {
        img.classList.toggle("is-active", img.getAttribute("data-flavor-art") === flavor);
      });
      dots.forEach((dot) => {
        const isActive = dot.getAttribute("data-flavor") === flavor;
        dot.classList.toggle("is-active", isActive);
        dot.setAttribute("aria-selected", String(isActive));
      });
    }

    function pickDesktopFlavor() {
      const targetY = window.innerHeight * 0.42;
      let bestItem = null;
      let bestDistance = Infinity;

      listItems.forEach((item) => {
        const rect = item.getBoundingClientRect();
        if (rect.bottom < targetY - 120 || rect.top > targetY + 120) return;
        const itemY = rect.top + rect.height * 0.35;
        const distance = Math.abs(itemY - targetY);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestItem = item;
        }
      });

      if (bestItem) {
        setActive(bestItem.getAttribute("data-flavor"));
      }
    }

    function pickMobileFlavor() {
      if (!track || !slides.length) return;
      const center = track.scrollLeft + track.clientWidth / 2;
      let closest = slides[0];
      let closestDistance = Infinity;

      slides.forEach((slide) => {
        const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
        const distance = Math.abs(slideCenter - center);
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = slide;
        }
      });

      setActive(closest.getAttribute("data-flavor"));
    }

    function scheduleUpdate(mode) {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        if (mode === "mobile") {
          pickMobileFlavor();
        } else {
          pickDesktopFlavor();
        }
      });
    }

    function teardownShowcaseListeners() {
      if (desktopScrollHandler) {
        window.removeEventListener("scroll", desktopScrollHandler);
        desktopScrollHandler = null;
      }
      if (mobileScrollHandler && track) {
        track.removeEventListener("scroll", mobileScrollHandler);
        mobileScrollHandler = null;
      }
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    function scrollSlideIntoView(slide) {
      if (!track || !slide) return;
      const offset = slide.offsetLeft - (track.clientWidth - slide.clientWidth) / 2;
      track.scrollTo({ left: offset, behavior: prefersReducedMotion ? "auto" : "smooth" });
    }

    function bindDots() {
      if (dotsBound) return;
      dots.forEach((dot) => {
        dot.addEventListener("click", () => {
          const flavor = dot.getAttribute("data-flavor");
          const slide = section.querySelector(`.showcase-slide[data-flavor="${flavor}"]`);
          if (slide) scrollSlideIntoView(slide);
          setActive(flavor);
        });
      });
      dotsBound = true;
    }

    function initDesktop() {
      teardownShowcaseListeners();
      if (!listItems.length) return;
      desktopScrollHandler = () => scheduleUpdate("desktop");
      window.addEventListener("scroll", desktopScrollHandler, { passive: true });
      scheduleUpdate("desktop");
    }

    function initMobile() {
      teardownShowcaseListeners();
      if (!track || !slides.length) return;
      bindDots();
      mobileScrollHandler = () => scheduleUpdate("mobile");
      track.addEventListener("scroll", mobileScrollHandler, { passive: true });
      scheduleUpdate("mobile");
    }

    function syncMode() {
      activeFlavor = null;
      if (MOBILE_SHOWCASE_MQ.matches) {
        initMobile();
      } else {
        initDesktop();
      }
    }

    syncMode();
    MOBILE_SHOWCASE_MQ.addEventListener("change", syncMode);
  }

  function initHeroTilt() {
    if (prefersReducedMotion) return;
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

    const stage = document.querySelector(".hero-visual");
    const frame = stage ? stage.querySelector(".hero-visual-frame") : null;
    if (!stage || !frame) return;

    const MAX_TILT = 4;
    let frameId = null;

    stage.addEventListener(
      "pointermove",
      (event) => {
        if (frameId) cancelAnimationFrame(frameId);
        frameId = requestAnimationFrame(() => {
          const rect = frame.getBoundingClientRect();
          const nx = Math.max(-1, Math.min(1, ((event.clientX - rect.left) / rect.width) * 2 - 1));
          const ny = Math.max(-1, Math.min(1, ((event.clientY - rect.top) / rect.height) * 2 - 1));
          const magnitude = Math.min(1, Math.hypot(nx, ny));
          if (magnitude < 0.01) {
            frame.style.rotate = "none";
            return;
          }
          frame.style.rotate = `${(-ny).toFixed(3)} ${nx.toFixed(3)} 0 ${(MAX_TILT * magnitude).toFixed(2)}deg`;
        });
      },
      { passive: true }
    );

    stage.addEventListener("pointerleave", () => {
      if (frameId) cancelAnimationFrame(frameId);
      frame.style.rotate = "none";
    });
  }

  window.TRAYN_FX = {
    addToCart(btn) {
      if (!btn || prefersReducedMotion) return Promise.resolve();

      btn.classList.add("is-added");
      setTimeout(() => btn.classList.remove("is-added"), 1200);

      const card = btn.closest(".showcase-slide, .showcase-item, .flavor-card, .product-page-layout");
      const img = card ? card.querySelector(".showcase-slide-art img, .showcase-item-art img, picture img, img") : null;
      const target = document.querySelector(".cart-button");
      if (!img || !target || typeof img.animate !== "function") {
        this.popBadge();
        return Promise.resolve();
      }

      const from = img.getBoundingClientRect();
      const to = target.getBoundingClientRect();
      if (!from.width || !to.width) {
        this.popBadge();
        return Promise.resolve();
      }

      const clone = img.cloneNode(false);
      clone.className = "fly-to-cart";
      clone.style.left = `${from.left}px`;
      clone.style.top = `${from.top}px`;
      clone.style.width = `${from.width}px`;
      clone.style.height = `${from.height}px`;
      document.body.appendChild(clone);

      const dx = to.left + to.width / 2 - (from.left + from.width / 2);
      const dy = to.top + to.height / 2 - (from.top + from.height / 2);

      const animation = clone.animate(
        [
          { transform: "translate(0, 0) scale(1)", opacity: 1 },
          { transform: `translate(${dx * 0.5}px, ${dy * 0.5 - 90}px) scale(0.4)`, opacity: 0.9, offset: 0.55 },
          { transform: `translate(${dx}px, ${dy}px) scale(0.08)`, opacity: 0.25 },
        ],
        { duration: 650, easing: "cubic-bezier(0.5, -0.1, 0.7, 1)" }
      );

      return animation.finished
        .catch(() => {})
        .then(() => {
          clone.remove();
          this.popBadge();
        });
    },

    popBadge() {
      document.querySelectorAll("[data-cart-count]").forEach((el) => {
        el.classList.remove("badge-pop");
        void el.offsetWidth;
        el.classList.add("badge-pop");
      });
    },
  };

  function initCursorSpotlight() {
    if (prefersReducedMotion) return;
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

    const selector = ".flavor-card, .trust-strip article, .quality-list article, .hero-stats li, .hero-visual-frame";
    let frame = null;

    document.addEventListener(
      "pointermove",
      (event) => {
        const target = event.target instanceof Element ? event.target.closest(selector) : null;
        if (!target) return;

        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const rect = target.getBoundingClientRect();
          target.style.setProperty("--mx", `${event.clientX - rect.left}px`);
          target.style.setProperty("--my", `${event.clientY - rect.top}px`);
        });
      },
      { passive: true }
    );
  }

  function initTouchGlow() {
    if (prefersReducedMotion || !isCoarsePointer) return;

    const selector = ".showcase-slide, .trust-strip article, .quality-list article, .hero-stats li";

    function setGlowPoint(target, event) {
      const rect = target.getBoundingClientRect();
      target.style.setProperty("--mx", `${event.clientX - rect.left}px`);
      target.style.setProperty("--my", `${event.clientY - rect.top}px`);
    }

    function clearGlow() {
      document.querySelectorAll(`${selector}.is-touch-glow`).forEach((el) => {
        el.classList.remove("is-touch-glow");
      });
    }

    document.addEventListener(
      "pointerdown",
      (event) => {
        const target = event.target instanceof Element ? event.target.closest(selector) : null;
        if (!target) return;
        clearGlow();
        setGlowPoint(target, event);
        target.classList.add("is-touch-glow");
      },
      { passive: true }
    );

    document.addEventListener("pointerup", clearGlow, { passive: true });
    document.addEventListener("pointercancel", clearGlow, { passive: true });
  }

  function initTouchTapFeedback() {
    if (prefersReducedMotion || !isCoarsePointer) return;

    document.addEventListener(
      "pointerdown",
      (event) => {
        const slide = event.target instanceof Element ? event.target.closest(".showcase-slide") : null;
        if (!slide) return;
        slide.classList.add("is-tap-active");
      },
      { passive: true }
    );

    function clearTap() {
      document.querySelectorAll(".showcase-slide.is-tap-active").forEach((el) => {
        el.classList.remove("is-tap-active");
      });
    }

    document.addEventListener("pointerup", clearTap, { passive: true });
    document.addEventListener("pointercancel", clearTap, { passive: true });
  }

  function initHeaderScrollState() {
    const header = document.querySelector(".site-header");
    if (!header) return;

    function update() {
      header.classList.toggle("is-scrolled", window.scrollY > 12);
    }

    window.addEventListener("scroll", update, { passive: true });
    update();
  }

  function initScrollProgress() {
    const bar = document.querySelector(".scroll-progress");
    if (!bar) return;

    let ticking = false;

    function update() {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const progress = max > 0 ? window.scrollY / max : 0;
      bar.style.transform = `scaleX(${Math.min(Math.max(progress, 0), 1)})`;
      ticking = false;
    }

    window.addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
    window.addEventListener("resize", update);
    update();
  }

  function initReveal() {
    const targets = document.querySelectorAll(
      "main > section:not(.hero), main .shopify-section > section:not(.hero), .product-page-block.reveal"
    );
    if (!targets.length) return;

    if (prefersReducedMotion) {
      targets.forEach((el) => el.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
    );

    targets.forEach((el) => observer.observe(el));
  }

  function initStatCountUp() {
    const statsBlocks = document.querySelectorAll(".stats strong[data-count]");
    if (!statsBlocks.length || prefersReducedMotion) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          animateStat(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    statsBlocks.forEach((el) => observer.observe(el));
  }

  function animateStat(el) {
    const target = parseFloat(el.getAttribute("data-count"));
    const suffix = el.getAttribute("data-suffix") || "";
    if (Number.isNaN(target)) return;

    const decimals = String(target).includes(".") ? 1 : 0;
    const duration = 900;
    const start = performance.now();

    function frame(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = target * eased;
      el.textContent = `${value.toFixed(decimals)}${suffix}`;
      if (progress < 1) requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  function initStickyShopCta() {
    const cta = document.getElementById("sticky-shop-cta");
    const hero = document.querySelector(".hero");
    if (!cta || !hero) return;

    const mq = window.matchMedia("(max-width: 900px)");
    let heroBottom = 0;

    function measure() {
      heroBottom = hero.offsetTop + hero.offsetHeight;
    }

    function update() {
      if (!mq.matches) {
        cta.classList.remove("is-visible");
        cta.setAttribute("hidden", "");
        return;
      }

      cta.removeAttribute("hidden");
      cta.classList.toggle("is-visible", window.scrollY > heroBottom - 100);
    }

    measure();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", () => {
      measure();
      update();
    });
    mq.addEventListener("change", update);
    update();
  }

  function initProductStickyBar() {
    const bar = document.getElementById("product-sticky-bar");
    const form = document.querySelector(".product-form");
    const submitBtn = form?.querySelector(".product-form-submit");
    if (!bar || !form || !submitBtn) return;

    const mq = window.matchMedia("(max-width: 900px)");
    const stickyAdd = bar.querySelector("[data-sticky-add]");

    stickyAdd?.addEventListener("click", () => submitBtn.click());

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!mq.matches) {
          bar.classList.remove("is-visible");
          bar.setAttribute("hidden", "");
          return;
        }

        bar.removeAttribute("hidden");
        bar.classList.toggle("is-visible", !entry.isIntersecting);
      },
      { threshold: 0, rootMargin: "0px 0px -1px 0px" }
    );

    observer.observe(submitBtn);
    mq.addEventListener("change", () => {
      if (!mq.matches) {
        bar.classList.remove("is-visible");
        bar.setAttribute("hidden", "");
      }
    });
  }
})();
